import { Octree } from '../Octree';
import { OctreeNode } from '../OctreeNode';

export class QueueItem {
  constructor(
    public octree: Octree,
    public octreeNode: OctreeNode,
    public weight: number
  ) {}
}
